import invalidate from '../../util/invalidate';
import mustRender from '../../util/mustRender';

function fetchAxisIntervalInfo(state, action) {
  if (!action.data) {
    return state;
  }

  if (action.data.status === 'success') {
    const { data } = action.data.body.chart;

    return {
      mobileXAxisInterval: data.mobileXAxisInterval || '',
      mobileXAxisIntervalSameAsDesktop: data.mobileXAxisIntervalSameAsDesktop,
      xAxisInterval: data.xAxisInterval,
      yAxisInterval: data.yAxisInterval,
      yAxisMobileEnabled: data.yAxisMobileEnabled,
      yAxisMobileInterval: data.yAxisMobileInterval,
      logScale: data.logScale || false,
      majorTicksArticle: data.majorTicksArticle || 'year',
      minorTicksArticle: data.minorTicksArticle || 'month',
      majorTicksPrint: data.majorTicksPrint || 'year',
      minorTicksPrint: data.minorTicksPrint || 'month',
      majorTicksPromo: data.majorTicksPromo || 'year',
      minorTicksPromo: data.minorTicksPromo || 'month',
      hiddenCategoriesArticle: data.hiddenCategoriesArticle || [],
      hiddenCategoriesPrint: data.hiddenCategoriesPrint || [],
      hiddenCategoriesPromo: data.hiddenCategoriesPromo || [],
      minorLabelsVisible: data.minorLabelsVisible,
      allowDecimals: data.allowDecimals === undefined ? true : data.allowDecimals,
      quarterlyResults: data.quarterlyResults,
    };
  }

  return state;
}

function updateChart(stateTree, state, payload, intervalType) {
  const { active } = stateTree.documents;

  let activeDoc = stateTree.documents.items[active];
  activeDoc = activeDoc.setIn(['chart', 'data', 'showTooltips'], false);
  activeDoc = invalidate(activeDoc, '*', 'chart/data');
  activeDoc = activeDoc.setIn(['mustRender'], mustRender(activeDoc));

  localStorage.setItem('saved', 'false');

  if (intervalType) {
    return {
      ...state,
      [intervalType]: payload,
      mustRender: activeDoc.mustRender,
    };
  }

  return state;
}

export { fetchAxisIntervalInfo, updateChart };
